import { Play, Pause, ChevronUp } from 'lucide-react';
import { usePlayer } from '@/context/PlayerContext';

export function MiniPlayer() {
  const {
    currentTrack,
    playbackState,
    currentTime,
    duration,
    isPlayerVisible,
    isFullScreen,
    pause,
    resume,
    setFullScreen,
  } = usePlayer();

  if (!isPlayerVisible || !currentTrack || isFullScreen) return null;

  const progressPercent = duration > 0 ? (currentTime / duration) * 100 : 0;
  const isPlaying = playbackState === 'playing';
  const isLoading = playbackState === 'loading';

  return (
    <div className="lg:hidden fixed bottom-16 left-0 right-0 bg-bg-elevated border-t border-subtle z-40">
      {/* Progress bar */}
      <div className="h-1 bg-bg-input">
        <div
          className="h-full bg-zzing-purple-500 transition-all"
          style={{ width: `${progressPercent}%` }}
        />
      </div>

      <div
        className="flex items-center gap-3 px-4 py-2 cursor-pointer"
        onClick={() => setFullScreen(true)}
      >
        {/* Cover */}
        {currentTrack.coverUrl ? (
          <img
            src={currentTrack.coverUrl}
            alt={currentTrack.title}
            className="w-12 h-12 rounded object-cover"
          />
        ) : (
          <div className="w-12 h-12 rounded bg-zzing-purple-500/20 flex items-center justify-center">
            <span className="text-zzing-purple-500 text-lg">♪</span>
          </div>
        )}

        {/* Track info */}
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-text-primary truncate">
            {currentTrack.title}
          </p>
          <p className="text-xs text-text-secondary truncate">
            {currentTrack.voicePart || currentTrack.artist}
          </p>
        </div>

        {/* Play/Pause button */}
        <button
          onClick={(e) => {
            e.stopPropagation();
            if (isPlaying) pause(); else resume();
          }}
          className="p-3 rounded-full bg-zzing-purple-500 text-white"
        >
          {isLoading ? (
            <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
          ) : isPlaying ? (
            <Pause className="w-5 h-5" />
          ) : (
            <Play className="w-5 h-5 ml-0.5" />
          )}
        </button>

        {/* Expand button */}
        <button
          onClick={(e) => {
            e.stopPropagation();
            setFullScreen(true);
          }}
          className="p-2 text-text-secondary"
        >
          <ChevronUp className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
}
